import type { GetProps } from "antd";
import { Typography } from "antd";
import type { FC } from "react";

export type IotTypographyTitleProps = GetProps<typeof Typography.Title>;

export const IotTypographyTitle: FC<IotTypographyTitleProps> = (props) => (
    <Typography.Title {...props} />
);
